import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const SettingsContext = createContext();

export function useSettings() {
  return useContext(SettingsContext);
}

export function SettingsProvider({ children }) {
  // Danh sách chia sẻ lịch: [{ id, department, sharedWith: [userId, ...] }, ...]
  const [scheduleShares, setScheduleShares] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Lắng nghe collection schedule_shares thay vì document settings/share_schedule
    const unsubscribe = onSnapshot(
      collection(db, 'schedule_shares'),
      (snapshot) => {
        const shares = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setScheduleShares(shares);
        setLoading(false);
      },
      (error) => {
        console.error('Lỗi khi lắng nghe cài đặt chia sẻ lịch:', error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  // Kiểm tra xem user có được chia sẻ lịch bộ phận nào không
  const canViewDepartmentSchedule = useCallback((userId, department) => {
    if (!userId || !department) return false;
    const share = scheduleShares.find(s => s.department === department);
    if (!share) return false;
    return share.sharedWith && share.sharedWith.includes(userId);
  }, [scheduleShares]);

  // Lấy danh sách bộ phận mà user được chia sẻ
  const getSharedDepartments = useCallback((userId) => {
    if (!userId) return [];
    return scheduleShares
      .filter(s => s.sharedWith && s.sharedWith.includes(userId))
      .map(s => s.department);
  }, [scheduleShares]);

  // Backward compatible: kiểm tra nếu user có ít nhất 1 share
  const isShareScheduleEnabled = useCallback((userId) => {
    if (!userId) return false;
    return scheduleShares.some(s => s.sharedWith && s.sharedWith.includes(userId));
  }, [scheduleShares]);

  const value = {
    scheduleShares,
    canViewDepartmentSchedule,
    getSharedDepartments,
    isShareScheduleEnabled,
    // Backward compatible — giữ tên cũ nhưng giờ luôn false (chỉ dùng isShareScheduleEnabled(userId))
    shareScheduleEnabled: false,
    loading
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
}